import { signInAnonymously, PhoneAuthProvider, signInWithCredential } from "firebase/auth";
const { Firebase } = require("./firebase");

let authInFlightPromise = null;

export const authenticateAnonymousUser = async () => {
	if (authInFlightPromise) {
		return authInFlightPromise;
	}

	authInFlightPromise = (async () => {
		if (Firebase.currentUser) {
			return Firebase.currentUser;
		}

		const auth = Firebase;
		return signInAnonymously(auth);
	})();

	try {
		return await authInFlightPromise;
	} finally {
		authInFlightPromise = null;
	}
};

export const waitForAuthIdle = async () => {
	if (authInFlightPromise) {
		await authInFlightPromise;
	}
};

export const isAuthInProgress = () => Boolean(authInFlightPromise);

export const getCredential = (verificationId, code) => {
	return PhoneAuthProvider.credential(verificationId, code);
};

export const authenticateUser = async (credential) => {
	const auth = Firebase;
	return await signInWithCredential(auth, credential);
};

export default { authenticateAnonymousUser, waitForAuthIdle, isAuthInProgress, getCredential, authenticateUser };
